// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file aiUnitHourly/aiUnitHourly.proto (package aiUnitHourlyCummulative, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * AiUnitThresholdSeverity enumerates the severity levels a user can attach to a custom threshold.
 * Levels are ordered from least to most urgent.
 *
 * @generated from enum aiUnitHourlyCummulative.AiUnitThresholdSeverity
 */
export enum AiUnitThresholdSeverity {
/**
 * @generated from enum value: AI_UNIT_THRESHOLD_SEVERITY_UNSPECIFIED = 0;
 */
UNSPECIFIED = "AI_UNIT_THRESHOLD_SEVERITY_UNSPECIFIED",

/**
 * @generated from enum value: AI_UNIT_THRESHOLD_SEVERITY_INFO = 1;
 */
INFO = "AI_UNIT_THRESHOLD_SEVERITY_INFO",

/**
 * @generated from enum value: AI_UNIT_THRESHOLD_SEVERITY_LOW = 2;
 */
LOW = "AI_UNIT_THRESHOLD_SEVERITY_LOW",

/**
 * @generated from enum value: AI_UNIT_THRESHOLD_SEVERITY_WARN = 3;
 */
WARN = "AI_UNIT_THRESHOLD_SEVERITY_WARN",

/**
 * @generated from enum value: AI_UNIT_THRESHOLD_SEVERITY_HIGH = 4;
 */
HIGH = "AI_UNIT_THRESHOLD_SEVERITY_HIGH",

/**
 * @generated from enum value: AI_UNIT_THRESHOLD_SEVERITY_CRITICAL = 5;
 */
CRITICAL = "AI_UNIT_THRESHOLD_SEVERITY_CRITICAL",
}
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlyCummulativeRequest
 */
export type AiUnitHourlyCummulativeRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * IANA timezone name (e.g. "Asia/Colombo"). The daily buckets in the response follow it, so
 * DST transitions inside the range are handled correctly and the days stay right even when no
 * dates are sent. Falls back to the fixed offset carried by start_date when empty.
 *
 * @generated from field: string timezone = 5;
 */
timezone?: string;
/**
 * @generated from field: aiUnitHourlyCummulative.AiUnitHourlyCummulativeRequest.Type type = 3;
 */
type?: AiUnitHourlyCummulativeRequest_Type;
/**
 * @generated from field: aiUnitHourlyCummulative.UserContext user_context = 4;
 */
userContext?: UserContext;
}
;
/**
 * @generated from enum aiUnitHourlyCummulative.AiUnitHourlyCummulativeRequest.Type
 */
export enum AiUnitHourlyCummulativeRequest_Type {
/**
 * @generated from enum value: SUMMARY = 0;
 */
SUMMARY = "SUMMARY",

/**
 * @generated from enum value: COMPONENT = 1;
 */
COMPONENT = "COMPONENT",
}
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlyComponentRequest
 */
export type AiUnitHourlyComponentRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * IANA timezone name (e.g. "Asia/Colombo"). The daily buckets in the response follow it, so
 * DST transitions inside the range are handled correctly and the days stay right even when no
 * dates are sent. Falls back to the fixed offset carried by start_date when empty.
 *
 * @generated from field: string timezone = 4;
 */
timezone?: string;
/**
 * @generated from field: aiUnitHourlyCummulative.UserContext user_context = 3;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlySummaryRequest
 */
export type AiUnitHourlySummaryRequest = {
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlyCummulativeResponse
 */
export type AiUnitHourlyCummulativeResponse = {
}
 & (
{ 
/**
 * @generated from field: aiUnitHourlyCummulative.CumulativeHourlyUsageSummaryResponse summary_response = 1;
 */
summaryResponse?: CumulativeHourlyUsageSummaryResponse;
 }
 | 
{ 
/**
 * @generated from field: aiUnitHourlyCummulative.ComponentHourlyUsageResponse component_response = 2;
 */
componentResponse?: ComponentHourlyUsageResponse;
 }
)
;
/**
 * @generated from message aiUnitHourlyCummulative.CumulativeHourlyUsageSummaryResponse
 */
export type CumulativeHourlyUsageSummaryResponse = {
/**
 * @generated from field: map<string, float> data = 1;
 */
data?: { [key: string]: number };
}
;
/**
 * @generated from message aiUnitHourlyCummulative.ComponentHourlyUsageResponse
 */
export type ComponentHourlyUsageResponse = {
/**
 * @generated from field: map<string, aiUnitHourlyCummulative.AIUnitComponentUsage> data = 1;
 */
data?: { [key: string]: AIUnitComponentUsage };
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AIUnitComponentUsage
 */
export type AIUnitComponentUsage = {
/**
 * @generated from field: optional float mlops_deployments = 1;
 */
mlopsDeployments?: number;
/**
 * @generated from field: optional float h2ogpt = 2;
 */
h2ogpt?: number;
/**
 * @generated from field: optional float h2ogpte_playground = 3;
 */
h2ogptePlayground?: number;
/**
 * @generated from field: optional float mlops = 4;
 */
mlops?: number;
/**
 * @generated from field: optional float doc_ai_proxy = 5;
 */
docAiProxy?: number;
/**
 * @generated from field: optional float aiem_workload = 6;
 */
aiemWorkload?: number;
/**
 * @generated from field: optional float appstore = 7;
 */
appstore?: number;
/**
 * @generated from field: optional float steam = 8;
 */
steam?: number;
/**
 * @generated from field: optional float ml_api = 9;
 */
mlApi?: number;
/**
 * @generated from field: optional float rest_scorer = 10;
 */
restScorer?: number;
/**
 * @generated from field: optional float document_ai = 11;
 */
documentAi?: number;
/**
 * @generated from field: optional float notebook_workload = 12;
 */
notebookWorkload?: number;
/**
 * @generated from field: optional float appstore_apps = 13;
 */
appstoreApps?: number;
/**
 * @generated from field: optional float na = 14;
 */
na?: number;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlySummaryResponse
 */
export type AiUnitHourlySummaryResponse = {
/**
 * Contract start date
 *
 * @generated from field: string envStartDate = 1;
 */
envStartDate?: string;
/**
 * Contract end date
 *
 * @generated from field: string envEndDate = 2;
 */
envEndDate?: string;
/**
 * Purchased AI Unit
 *
 * @generated from field: string purchasedAIUnits = 3;
 */
purchasedAIUnits?: string;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlyEvent
 */
export type AiUnitHourlyEvent = {
/**
 * @generated from field: string ts = 1;
 */
ts?: string;
/**
 * Resource
 *
 * @generated from field: string resource = 4;
 */
resource?: string;
/**
 * AI unit count
 *
 * @generated from field: float ai_units = 5;
 */
aiUnits?: number;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitUsageThresholdRequest
 */
export type AiUnitUsageThresholdRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitUsageThresholdResponse
 */
export type AiUnitUsageThresholdResponse = {
/**
 * @generated from field: float threshold = 1;
 */
threshold?: number;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlyDateRangeRequest
 */
export type AiUnitHourlyDateRangeRequest = {
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlyDateRangeResponse
 */
export type AiUnitHourlyDateRangeResponse = {
/**
 * @generated from field: string first_date = 1;
 */
firstDate?: string;
/**
 * @generated from field: string last_date = 2;
 */
lastDate?: string;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * CustomAiUnitThreshold expresses an alert level as a percentage of the calculated
 * environment-period AI unit threshold (the value returned by GetAiUnitUsageThreshold).
 *
 * @generated from message aiUnitHourlyCummulative.CustomAiUnitThreshold
 */
export type CustomAiUnitThreshold = {
/**
 * 1-100 inclusive
 *
 * @generated from field: int32 percentage = 1;
 */
percentage?: number;
/**
 * @generated from field: aiUnitHourlyCummulative.AiUnitThresholdSeverity severity = 2;
 */
severity?: AiUnitThresholdSeverity;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.GetCustomAiUnitThresholdsRequest
 */
export type GetCustomAiUnitThresholdsRequest = {
}
;
/**
 * @generated from message aiUnitHourlyCummulative.GetCustomAiUnitThresholdsResponse
 */
export type GetCustomAiUnitThresholdsResponse = {
/**
 * @generated from field: repeated aiUnitHourlyCummulative.CustomAiUnitThreshold thresholds = 1;
 */
thresholds?: CustomAiUnitThreshold[];
}
;
/**
 * @generated from message aiUnitHourlyCummulative.UpdateCustomAiUnitThresholdsRequest
 */
export type UpdateCustomAiUnitThresholdsRequest = {
/**
 * @generated from field: repeated aiUnitHourlyCummulative.CustomAiUnitThreshold thresholds = 1;
 */
thresholds?: CustomAiUnitThreshold[];
/**
 * @generated from field: aiUnitHourlyCummulative.UserContext user_context = 2;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.UpdateCustomAiUnitThresholdsResponse
 */
export type UpdateCustomAiUnitThresholdsResponse = {
/**
 * @generated from field: bool success = 1;
 */
success?: boolean;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.GetAiUnitExceedLimitRequest
 */
export type GetAiUnitExceedLimitRequest = {
}
;
/**
 * @generated from message aiUnitHourlyCummulative.GetAiUnitExceedLimitResponse
 */
export type GetAiUnitExceedLimitResponse = {
/**
 * @generated from field: bool is_exceed_limit = 1;
 */
isExceedLimit?: boolean;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitUsageForecastRequest
 */
export type AiUnitUsageForecastRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00").
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * Used only to align forecast daily bucketing with the caller's
 * timezone; the forecast baseline is always the contract period.
 *
 * @generated from field: aiUnitHourlyCummulative.UserContext user_context = 2;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitUsageForecastResponse
 */
export type AiUnitUsageForecastResponse = {
/**
 * YYYY-MM-DD -> projected cumulative AI units,
 *
 * @generated from field: map<string, float> forecast_data = 1;
 */
forecastData?: { [key: string]: number };
/**
 * starting the day after last_actual_date.
 * Empty when there is insufficient usage history.
 *
 * YYYY-MM-DD when cumulative usage is expected to
 *
 * @generated from field: string predicted_threshold_date = 2;
 */
predictedThresholdDate?: string;
/**
 * reach 100% of the contract threshold. A past date
 * if already exceeded; empty if unreachable at the
 * current burn rate or there is no data.
 *
 * The 100% contract threshold in AI units.
 *
 * @generated from field: float threshold = 3;
 */
threshold?: number;
/**
 * Trend slope in AI units per day.
 *
 * @generated from field: float daily_burn_rate = 4;
 */
dailyBurnRate?: number;
/**
 * YYYY-MM-DD of the last actual data point the
 *
 * @generated from field: string last_actual_date = 5;
 */
lastActualDate?: string;
/**
 * forecast is anchored to.
 *
 * Cumulative AI units at last_actual_date.
 *
 * @generated from field: float last_actual_cumulative = 6;
 */
lastActualCumulative?: number;
}
;
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetHourlyAiUnitCummulativeUsage
 */
export const AiUnitHourlyService_GetHourlyAiUnitCummulativeUsage = new RPC<AiUnitHourlyCummulativeRequest,AiUnitHourlyCummulativeResponse>("POST", "/getHourlyAiUnitCummulativeUsage");
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetHourlyAiUnitComponentUsage
 */
export const AiUnitHourlyService_GetHourlyAiUnitComponentUsage = new RPC<AiUnitHourlyComponentRequest,ComponentHourlyUsageResponse>("POST", "/getHourlyAiUnitComponentUsage");
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetHourlyAiUnitSummary
 */
export const AiUnitHourlyService_GetHourlyAiUnitSummary = new RPC<AiUnitHourlySummaryRequest,AiUnitHourlySummaryResponse>("GET", "/getHourlyAiUnitSummary");
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetAiUnitUsageThreshold
 */
export const AiUnitHourlyService_GetAiUnitUsageThreshold = new RPC<AiUnitUsageThresholdRequest,AiUnitUsageThresholdResponse>("GET", "/getAiUnitUsageThreshold");
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetAiUnitHourlyDateRange
 */
export const AiUnitHourlyService_GetAiUnitHourlyDateRange = new RPC<AiUnitHourlyDateRangeRequest,AiUnitHourlyDateRangeResponse>("GET", "/getAiUnitHourlyDateRange");
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetCustomAiUnitThresholds
 */
export const AiUnitHourlyService_GetCustomAiUnitThresholds = new RPC<GetCustomAiUnitThresholdsRequest,GetCustomAiUnitThresholdsResponse>("GET", "/getCustomAiUnitThresholds");
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.UpdateCustomAiUnitThresholds
 */
export const AiUnitHourlyService_UpdateCustomAiUnitThresholds = new RPC<UpdateCustomAiUnitThresholdsRequest,UpdateCustomAiUnitThresholdsResponse>("POST", "/updateCustomAiUnitThresholds");
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetAiUnitExceedLimit
 */
export const AiUnitHourlyService_GetAiUnitExceedLimit = new RPC<GetAiUnitExceedLimitRequest,GetAiUnitExceedLimitResponse>("GET", "/getAiUnitExceedLimit");
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetAiUnitUsageForecast
 */
export const AiUnitHourlyService_GetAiUnitUsageForecast = new RPC<AiUnitUsageForecastRequest,AiUnitUsageForecastResponse>("POST", "/getAiUnitUsageForecast");
